import { Box, Popover, Tooltip } from '@mui/material';
import { Assay, lbAssays, lbAssayValues } from '@zero-dash/types';
import { Dispatch, JSX, SetStateAction } from 'react';
import { CustomCheckbox } from '@/components/Input/CustomCheckbox';
import CustomButton from '@/components/Common/Button';

const WGS_MUTUALLY_EXCLUSIVE: Assay[] = ['LB_Germline_WGS', 'LB_Tumour_WGS'];

interface IProps {
  anchorEl: null | HTMLElement;
  handleClose: () => void;
  selectedAssays: Assay[];
  setSelectedAssays: Dispatch<SetStateAction<Assay[]>>;
  onApplyAssays: () => void;
}

export default function AssayMenu({
  anchorEl,
  handleClose,
  selectedAssays,
  setSelectedAssays,
  onApplyAssays,
}: IProps): JSX.Element {
  return (
    <Popover
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      open={Boolean(anchorEl)}
      onClose={handleClose}
      disableRestoreFocus
      slotProps={{
        paper: { sx: { padding: '8px' } },
      }}
    >
      <Box
        display="flex"
        flexDirection="column"
      >
        {lbAssayValues.map((assay) => {
          const mateAssay = WGS_MUTUALLY_EXCLUSIVE.find(
            (a) => a !== assay && selectedAssays.includes(a),
          );
          const isDisabled = WGS_MUTUALLY_EXCLUSIVE.includes(assay) && !!mateAssay;

          return (
            <Tooltip
              key={assay}
              title={mateAssay ? `Cannot be selected alongside "${lbAssays[mateAssay]}"` : ''}
              placement="right"
              disableFocusListener={!isDisabled}
              disableHoverListener={!isDisabled}
              disableTouchListener={!isDisabled}
            >
              <Box>
                <CustomCheckbox
                  checked={selectedAssays.includes(assay)}
                  disabled={isDisabled}
                  labelProps={{ label: lbAssays[assay], sx: { padding: '8px' }, disabled: isDisabled }}
                  onChange={(e): void => setSelectedAssays(
                    (prev) => (
                      e.target.checked
                        ? [...prev, assay]
                        : prev.filter((a) => a !== assay)
                    ),
                  )}
                />
              </Box>
            </Tooltip>
          );
        })}
        <CustomButton
          label="Apply"
          size="small"
          sx={{ width: '200px' }}
          onClick={onApplyAssays}
          disabled={!selectedAssays.length}
        />
      </Box>
    </Popover>
  );
}
